import Vue from "vue";
import VueAxios from "vue-axios";
import axios from 'axios';
import i18n from "@/i18n";
import app from "@/main";

Vue.use(VueAxios, axios);

Vue.axios.interceptors.response.use(null, function (error) {
    let message = error.message;
    let title = i18n.t('Error');

    if (error.response) {
        let response = error.response;

        message = response.data ? response.data.message || response.statusText : response.statusText;

        if (response.status === 422) {
            title = i18n.t('Validation error');
            message = i18n.t('Please check your inputs');
        }
        if (response.status === 413) {
            title = i18n.t('Payload Too Large');
            message = i18n.t('The uploaded content exceeds the servers allowed size.');
        }

        if (response.status === 412) { //Precondition Failed
            title = i18n.t('Unhandled relations');
        }


        if (response.status === 503) {
            title = i18n.t('Service Unavailable');
            message = i18n.t('Sorry, we are doing some maintenance. Please check back soon.');
        }
    }

    if(message === 'Network Error') {
        app.$bvToast.toast(i18n.t('Please try again later'), {
            title: i18n.t('Network error'),
            variant: 'danger',
            solid: true,
            autoHideDelay: 10000
        });

        return Promise.reject(Object.assign(error, {response: {}}));
    } else {

        app.$bvToast.toast(message, {
            title,
            variant: 'danger',
            solid: true,
            autoHideDelay: 10000
        });
    }

    return Promise.reject(error);
})
